// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const radiusSix = (props) => `
    ${props.spcBag && props.theme.brand !== 'gym' ? `border-radius: 6px` : ''};
`;

const getBgColor = (props) => {
  if (props?.isFromBagPage) {
    if (props.coupon?.labelStatus === 'REMOVE' || props.coupon?.labelStatus === 'removing') {
      return `background-color: ${props.theme.colors.WHITE};color:black;`;
    }
    return `background-color: ${props.theme.colors.BLACK};color:white;`;
  }
  return `background-color: ${props.theme.colors.WHITE};color:black;`;
};

const isDrawerORDashboardORPerk = (props) => {
  return (
    props.isAccountDrawer ||
    props.isAccountDashboard ||
    (props.isPlacePerkEnabled && props.isPlacePerks)
  );
};

const minHeightCoupon = (props) => {
  if (props.isCartPageCouponSection) {
    return 'min-height: 142px;';
  }
  if (
    props.couponSectionNewDesign ||
    (isDrawerORDashboardORPerk(props) && !props.isCartPageCouponSection)
  ) {
    return 'min-height: 203px;';
  }
  return '';
};

const styles = css`
  .couponCard__container_loader {
    position: absolute;
    background: rgba(26, 26, 26, 0.4);
    width: ${(props) => {
      if (props.isAccountDashboard) {
        return props.couponListSize > 3 ? `16%;` : `96%;`;
      }
      if (props.isCartPageCouponSection && props.spc) {
        return props.couponListSize > 1 ? `30.6%` : `92%;`;
      }
      if (props.isCartPageCouponSection) {
        if (props.couponListSize > 3) {
          return '11.9%';
        }
        return props.couponListSize > 1 ? `31.7%` : `92%;`;
      }
      if (props.isAccountDrawer) {
        return props.couponListSize > 1 ? `14.6%;` : `87%;`;
      }

      return null;
    }};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: ${(props) => {
        if (props.isCartPageCouponSection && props.spc) {
          return props.couponListSize > 1 ? `30.6%` : `92%;`;
        }
        if (props.isCartPageCouponSection) {
          return props.couponListSize > 1 ? `325px` : `95%;`;
        }
        return null;
      }};
    }
    height: ${(props) => {
      if (props.isCartPageCouponSection && props.spc) {
        return `124px;`;
      }
      if (props.isCartPageCouponSection && !props.spc) {
        return `125px;`;
      }
      return `212px`;
    }};

    z-index: 20000;
    border-radius: 6px;
  }
  .couponCard__container {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    ${(props) =>
      props.isAccountDashboard && `margin-right: ${props.theme.spacing.ELEM_SPACING.LRG}`};
  }
  .couponCard__header {
    display: flex;
    ${(props) => props.isCartPageCouponSection && `height:48px`};
  }

  .semi-rounded-stripe {
    border-radius: ${(props) => (props.spc ? '6px 6px 0 0' : '10px 10px 0 0')};

    ${(props) =>
      isDrawerORDashboardORPerk(props)
        ? `
      border-radius: 6px 6px 0 0;
    `
        : ''};
  }

  .couponCard__container_error {
    border: solid 1px ${(props) => props.theme.colors.TEXT.RED};
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  }

  .couponCard__container_main {
    padding-bottom: 10px;
    border: solid 1px ${(props) => props.theme.colors.BRAND.BOY};
    border-style: dashed;
    ${(props) => props.isCartPageCouponSection && `height:auto;`};
    ${(props) => minHeightCoupon(props)};

    ${(props) =>
      props.spc
        ? `
        height: ${props.isCartPageCouponSection ? `auto` : '124px'};
        border-radius: ${props.theme.spacing.ELEM_SPACING.XS_6};
        margin-right:12px;
      `
        : ''};
    ${(props) =>
      isDrawerORDashboardORPerk(props)
        ? `
      border: none;
      border-radius: ${props.theme.spacing.ELEM_SPACING.XS_6};
      box-shadow: 0px 0px 5px 1px ${props.theme.colorPalette.gray[3300]};
    `
        : ''};
  }

  .couponCard__header_pc {
    flex: 1;
    background: ${(props) => props.theme.colors.PRIMARY.GREEN};
    ${(props) =>
      props.isAccountDrawer || props.isAccountDashboard
        ? `
      background: linear-gradient(118deg, #4B742D 51%, #70B043 51%);
      height: ${props.isCartPageCouponSection ? '50px' : '70px'};
    `
        : ''};
  }
  .couponCard__header_saving {
    flex: 1;
    background: ${(props) => props.theme.colors.BRAND.GIRLS};
    ${(props) => props.isCartPageCouponSection && `height:48px !important;`};
    ${(props) =>
      props.isAccountDrawer || props.isAccountDashboard
        ? `
      justify-content: space-between;
      display: flex;
      align-items: center;
      align-content: center;
      background: linear-gradient(118deg, #ED40A9 70%, #F470BA 60%);
      height: ${props.isCartPageCouponSection ? '50px' : '70px'};
    `
        : ''};
  }

  .couponCard__header_on_hold {
    flex: 1;
    background: ${(props) => props.theme.colors.PRIMARY.GREEN};
  }
  .couponCard__header_rewards {
    flex: 1;
    background: ${(props) => props.theme.colorPalette.orange[800]};
    ${(props) =>
      props.isAccountDrawer || props.isAccountDashboard
        ? `
      background: linear-gradient(118deg, #F7971F 70%, #F8AB4B 60%);
      height: ${props.isCartPageCouponSection ? '50px' : '70px'};
    `
        : ''};
  }
  .couponCard__header_placeperks {
    flex: 1;
    background: ${(props) => props.theme.colorPalette.blue[500]};
    ${(props) =>
      isDrawerORDashboardORPerk(props)
        ? `
      background: linear-gradient(118deg, ${props.theme.colorPalette.blue[500]} 70%, ${
            props.theme.colorPalette.blue[1500]
          } 60%);
      height:  ${props.isCartPageCouponSection ? '50px' : '70px'};
    `
        : ''};
  }
  .couponCard__header_text {
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    color: ${(props) => props.theme.colors.BLACK};
    font-weight: ${(props) => props.theme.fonts.fontWeight.black};
    ${(props) => props.spc && `font-size:${props.theme.typography.fontSizes.fs12};`}
    width: max-content;
    background: ${(props) => props.theme.colors.WHITE};
    margin: 7px 0px 7px
      ${(props) => (props.isAccountDashboard ? props.theme.spacing.ELEM_SPACING.MED : '11px')};

    border-radius: 6px;
    ${(props) =>
      isDrawerORDashboardORPerk(props)
        ? `
      font-size: ${props.theme.typography.fontSizes.fs12};
      color: ${props.theme.colorPalette.gray[900]};
      border-radius: 30px;
      padding: 7px 20px;
      margin: 0px 0px 0px ${props.theme.spacing.ELEM_SPACING.MED};
      @media ${props.theme.mediaQuery.smallOnly} {
        padding: 7px 18px;
      }
    `
        : ''};
  }
  .couponCard__text_style {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};

    ${(props) =>
      props.isCartPageCouponSection &&
      `margin-bottom: ${props.theme.spacing.ELEM_SPACING.XXS}; margin-top:0;`}
    font-size: ${(props) => props.theme.typography.fontSizes.fs10};
    color: ${(props) => props.theme.colors.TEXT.DARK};
    ${(props) =>
      isDrawerORDashboardORPerk(props) && !props.isCartPageCouponSection
        ? `
      font-size: ${props.theme.typography.fontSizes.fs14};
    `
        : ''};
    ${(props) => props.isCartPageCouponSection && `font-weight:600`}
  }
  .cartDetailsLink {
    position: ${(props) => (props.isCarouselView || props.spc ? 'static' : 'absolute')};
    font-size: ${(props) =>
      props.spc || props.isCartPageCouponSection
        ? props.theme.typography.fontSizes.fs12
        : props.theme.typography.fontSizes.fs10};
    color: ${(props) => props.theme.colors.TEXT.DARK};
    ${(props) => (props.isCarouselView ? 'float: left;' : '')}
    text-decoration:underline;
    ${(props) =>
      props.isAccountDashboard || (props.isPlacePerkEnabled && props.isPlacePerks)
        ? `
      display:flex;
    `
        : ''};
    ${(props) =>
      isDrawerORDashboardORPerk(props) && !props.isCartPageCouponSection
        ? `
      font-size: ${props.theme.typography.fontSizes.fs14};
      margin-top: 20px;
    `
        : ''};
  }
  .couponCard__header_expired {
    flex: 1;
    text-align: center;
    background: ${(props) => props.theme.colors.TEXT.DARKERGRAY};
    color: ${(props) => props.theme.colors.WHITE};
    line-height: 36px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.black};
    border-radius: 0 10px 0 0;
    ${(props) =>
      isDrawerORDashboardORPerk(props)
        ? `
    background: none;
    flex: none;
    margin-right: ${props.theme.spacing.ELEM_SPACING.MED};
    `
        : ''};
  }

  .rounded-corner {
    border-radius: ${(props) =>
      props.isCartPageCouponSection || props.isWallet || isDrawerORDashboardORPerk(props)
        ? '7px 7px 0 0'
        : '10px 0 0 0'};
  }
  .couponCard__body {
    padding: ${(props) =>
        props.isCartPageCouponSection ? '0' : props.theme.spacing.ELEM_SPACING.XXS}
      ${(props) => props.theme.spacing.ELEM_SPACING.MED}
      ${(props) => props.theme.spacing.ELEM_SPACING.XS}
      ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  .couponCard__row {
    display: flex;
    margin-top: ${(props) => (props.spc ? '10px' : props.theme.spacing.APP_LAYOUT_SPACING.XS)};
    margin-bottom: ${(props) => (props.spc ? '10px' : props.theme.spacing.APP_LAYOUT_SPACING.XS)};
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      justify-content: space-between;
    }
    ${(props) =>
      isDrawerORDashboardORPerk(props)
        ? `
      flex-direction: column;
    `
        : ''};
  }
  .couponCard__col {
    flex: 1;
    padding-right: ${(props) =>
      props.isCarouselView || props.spc ? '0' : props.theme.spacing.ELEM_SPACING.SM};
    /* @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      flex: none;
      width: 60%;
    } */
    ${(props) => (props.spc ? `text-align: left;` : '')}
  }
  .coupon__button_black {
    background-color: ${(props) => props.theme.colors.BLACK};
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    min-width: ${(props) => (props.spc ? '50px' : '100px')};
    color: ${(props) => props.theme.colors.WHITE};
    font-size: ${(props) => props.theme.typography.fontSizes.fs10};
    ${(props) => radiusSix(props)}
    ${(props) =>
      props.isCarouselView
        ? `padding-left: ${props.theme.spacing.ELEM_SPACING.MED}; padding-right: ${props.theme.spacing.ELEM_SPACING.MED};`
        : ''}
        @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      ${(props) =>
        props.spc
          ? 'margin-left:5px;'
          : `min-width: 65px;
          max-width: 65px;`}
      padding: 10px;
    }
    ${(props) =>
      props.spc
        ? `
        width:80px;
        height:51px;
        padding:0px;
        border-radius:5px;font-size:${props.theme.typography.fontSizes.fs12}`
        : ''}
  }
  .coupon__button_black:hover,
  .coupon__button_black:focus {
    background-color: ${(props) => props.theme.colors.BUTTON.BLACK.HOVER};
    color: ${(props) => props.theme.colors.WHITE};
  }

  .coupon__button_white {
    font-size: ${(props) => props.theme.typography.fontSizes.fs10};
    min-width: ${(props) => (props.spc ? '50px' : '100px')};
    ${(props) => radiusSix(props)}
    border-radius:6px;
    ${(props) => getBgColor(props)}

    ${(props) => (props.isCarouselView ? `padding-right:0px; padding-left: 0px; ` : '')}
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      ${(props) =>
        props.spc
          ? 'margin-left:4px;'
          : !props.isWallet &&
            `min-width: 65px;
          `}
      padding: 10px;
    }
    ${(props) =>
      props.spc
        ? `width:80px;
      height:51px;
      padding:0px;
      border-radius:5px;
      font-size:${props.theme.typography.fontSizes.fs12};`
        : ''}
    ${(props) =>
      isDrawerORDashboardORPerk(props)
        ? `
        font-size: ${props.theme.typography.fontSizes.fs12};
        font-weight: ${props.theme.fonts.fontWeight.extrabold};
        width: 128px;
        height: 50px;
        position: relative;
        bottom: 30px;
        right:8px;
        `
        : ''};
    ${(props) =>
      props.isCartPageCouponSection &&
      `height: 32px; bottom:32px; min-height:10px; padding-top:8px; padding-bottom:8px;`}
  }
  .coupon__button_white:focus {
    ${(props) => getBgColor(props)};
  }
  .coupon__button_white:hover {
    ${(props) => getBgColor(props)};
  }
  .couponCard__container_error_text {
    color: ${(props) => props.theme.colors.TEXT.RED};
  }

  .couponCard_slick {
    ${(props) =>
      props.isCartPageCouponSection &&
      `margin-top:16px; margin-right:12px; margin-left: 2px; @media ${
        props.theme.mediaQuery.medium
      } {
        margin-right: ${props.spc ? '0px' : '12px'}}`}

    ${(props) =>
      !props.isCartPageCouponSection &&
      `
    margin: ${props.theme.spacing.ELEM_SPACING.MED}
      ${
        props.isAccountDashboard || (props.isPlacePerkEnabled && props.isPlacePerks)
          ? props.theme.spacing.ELEM_SPACING.XS
          : props.theme.spacing.ELEM_SPACING.LRG
      };`}
    .couponCard__row {
      margin: ${(props) => props.theme.spacing.ELEM_SPACING.XS} 0
        ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    }
  }

  .transparent-box {
    background: none;
    padding-bottom: 0;
    font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    color: ${(props) => props.theme.colorPalette.red[500]};
  }
  .couponTitle {
    word-break: ${(props) => (props.isCarouselView ? 'break-word' : 'normal')};
    ${(props) =>
      isDrawerORDashboardORPerk(props)
        ? `
      font-weight: ${props.theme.fonts.fontWeight.bold};
      font-size: ${props.theme.typography.fontSizes.fs16};
      line-height: 27px;
      text-transform: capitalize;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      `
        : ''};
    ${(props) =>
      props.isCartPageCouponSection &&
      `font-size: ${props.theme.typography.fontSizes.fs14}; line-height:19px; min-height: 38px`};
    ${(props) =>
      isDrawerORDashboardORPerk(props) && props.coupon.offerType === 'placeperks'
        ? `
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    `
        : ''};
    ${(props) =>
      !props.isCartPageCouponSection &&
      props.coupon.originalOfferType === 'BONUS-POINT-DAY' &&
      props.couponSectionNewDesign
        ? `
          font-size:${props.theme.typography.fontSizes.fs20};
          @media ${props.theme.mediaQuery.smallOnly} {
            font-size:${props.theme.typography.fontSizes.fs16};
          }
        `
        : ''};
  }
  .spc-container {
    width: 275px;
    height: 96px;
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  }

  .button-col {
    display: flex;
    justify-content: flex-end;
    align-items: normal;
    margin-right: -10px;
    margin-bottom: -30px;
  }
  .coupon_footer_wrapper {
    display: flex;
    justify-content: center;
  }
  .couponCard__footer_expired {
    box-sizing: border-box;
    display: flex;
    float: left;
    justify-content: center;
    align-items: center;
    position: relative;
    bottom: 8px;
    background: ${(props) => props.theme.colorPalette.white};
    border: 1px solid ${(props) => props.theme.colors.BORDER_WARNING_YELLOW};
    padding: 8px 16px;
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.LRG_2};
    ${(props) =>
      props.spc
        ? `
        margin-right:${props.theme.spacing.ELEM_SPACING.SM};
      `
        : ''};
  }
  .couponCard_applied_footer_expired {
    text-transform: capitalize;
    box-sizing: border-box;
    display: flex;
    float: left;
    justify-content: center;
    align-items: center;
    position: relative;
    bottom: 8px;
    background: ${(props) => props.theme.colorPalette.white};
    border: 1px solid ${(props) => props.theme.colorPalette.green[500]};
    padding: 8px 16px;
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.LRG_2};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      bottom: 5px;
    }
  }
  .couponCard_error_footer_expired {
    box-sizing: border-box;
    display: flex;
    float: left;
    justify-content: center;
    align-items: center;
    position: relative;
    bottom: 8px;
    background: ${(props) => props.theme.colorPalette.white};
    border: 1px solid ${(props) => props.theme.colorPalette.red[500]};
    padding: 8px 16px;
    border-radius: 30px;
    ${(props) => props.isCartPageCouponSection && `width: 90%;`};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) => props.isCartPageCouponSection && `width: 90%;`};
    }
  }

  .link-icon {
    margin-right: 10px;
    height: 14px;
    width: 16px;
  }

  .alignItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .rightHeaderPlaceCash {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .place-perks-star-coupon-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
  }
  .place-perks-star-header {
    width: 17px;
    height: 17px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    img {
      width: 9px;
    }
  }
  .star {
    background-color: ${(props) => props.theme.colorPalette.blue[1800]};
  }
  .rockstar {
    background-color: ${(props) => props.theme.colorPalette.blue[300]};
  }
  .superstar {
    background-color: ${(props) => props.theme.colorPalette.blue[1900]};
  }
  .megastar {
    background-color: ${(props) => props.theme.colorPalette.blue[800]};
  }

  .rightHeaderPlacePerks {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs24};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
  }
  .place-perks-image-container {
    img {
      margin-top: 6px;
    }
  }
  .hide-button {
    visibility: hidden;
  }
`;

export default styles;
